import {Box, IconButton, Typography} from '@viptech/react-components'
import React, {PropsWithChildren} from 'react'
import arrowLeftIcon from 'src/images/arrowLeftIcon.svg'
import closeIcon from 'src/images/closeIcon.svg'
import {useWindowSize} from 'usehooks-ts'
import Modal from './ModalCustom'

interface Props {
  title: string
  isOpen: boolean
  closeModal: () => void
  onReturn?: () => void
  children?: React.ReactNode
}

export default function ModalLateral({title, isOpen, closeModal, onReturn, children}: Props) {
  const windowSize = useWindowSize()

  const isMobile = windowSize.width <= 460

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} backgroundColor='white' minWidth={isMobile ? '100%' : '660px'} width='40%' height='100vh' isLateral>
      <Box padding='10px 24px 10px 30px' marginBottom='70px'>
        <Box display='flex' direction='row' flex={1} align='center' justifyContent='space-between'>
          <Box display='flex' columnGap='12px'>
            {onReturn && <img src={arrowLeftIcon} style={{cursor: 'pointer'}} onClick={onReturn} alt='Íconee' />}
            <Typography variant='h1' size='20px' color='#433942' weight={700}>
              {title}
            </Typography>
          </Box>
          <IconButton onClick={closeModal}>
            <img src={closeIcon} alt='close' width={16} height={16} color='#433942' />
          </IconButton>
        </Box>

        {children}
      </Box>
    </Modal>
  )
}

export function ModalLateralFooter({children}: PropsWithChildren) {
  return (
    <Box position='absolute' width='100%' left='0' bottom='0px' height='70px' backgroundColor='white'>
      {children}
    </Box>
  )
}
